"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
var createFeature_1 = require("../createFeature");
exports.setTitleAction = (_a = createFeature_1.createInputFeature('title'), _a.actionCreator), exports.titleSelector = _a.selectorCreator, exports.TitleFeature = _a.featureReducer;
//# sourceMappingURL=title.js.map